function randomInRange(min, max) {
    return Math.random() * (max - min) + min;
  }

  export default randomInRange